/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import PlanCourseCard from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/PlanCourseCard';
import TermRadioGroup from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/TermRadioGroup';
import UnknownAvailabilityNotification from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/UnknownAvailabilityNotification';
import type { CoursePlanDialogType } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/context/CoursePlanningDialogContext';
import type { UseCurriculum_PersonalizedSegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import { checkCourseHasUnknownAvailability } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';

const styles = {
  spacing: css`
    margin-bottom: var(--cds-spacing-300);
  `,
};

type CourseDialogProps = {
  course: SegmentCourse | null;
  dialogType: CoursePlanDialogType;
  selectedTerm: string;
  onTermSelected: (termId: string) => void;
  isError?: boolean;
};

const CourseDialog = ({ course, dialogType, selectedTerm, onTermSelected, isError }: CourseDialogProps) => {
  if (isError || !course) {
    return null;
  }

  const courseHasUnknownAvailability = checkCourseHasUnknownAvailability(course.segmentCourse);

  return (
    <React.Fragment>
      <div css={styles.spacing}>
        <PlanCourseCard course={course} />
      </div>
      {courseHasUnknownAvailability && <UnknownAvailabilityNotification styles={styles.spacing} />}
      <Grid item xs={12}>
        {!!course.segmentCourse.termAvailabilityPaginated?.elements &&
          (dialogType === 'add' || dialogType === 'move') && (
            <TermRadioGroup
              termAvailability={course.segmentCourse.termAvailabilityPaginated?.elements}
              selectedTerm={selectedTerm}
              onTermSelected={onTermSelected}
            />
          )}
      </Grid>
    </React.Fragment>
  );
};

export default CourseDialog;
